import * as React from 'react';
import { UserContext } from './user-provider';

function useUserContext() {
  const context = React.useContext(UserContext);
  if (!context) {
    throw new Error('`useUserContext` must be used within a <UserProvider>');
  }
  return context;
}

export function useUser() {
  const user = useUserContext();
  return user;
}
